import { PlaceholderSpeechBubble } from 'components/PlaceholderSpeechBubble';

export default PlaceholderSpeechBubble;
